import base64 from 'base-64';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import IAddFactory, {
  IBaseFactory,
} from '../../../models/forms/IAddUpdateFactory';
import { IAddEditFormProps } from '../../../models/forms/IForm';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import { StepFactoryDetails } from './steps/step-factory-details';
import { StepUserDetails } from './steps/step-user-details';

const AddFactoryForm = (props: IAddEditFormProps<IBaseFactory>) => {
  const [data, setData] = useState({ ...props.initialValues });
  const [currentStep, setCurrentStep] = useState<number>(0);

  useEffect(() => {
    setData({ ...props.initialValues });
  }, [props.initialValues]);

  const handleNextStep = (newData: any, final: boolean = false) => {
    setData((prev) => ({ ...prev, ...newData }));
    if (final) {
      let tempValues: IAddFactory = {
        ...newData,
        Password: String(base64.encode(newData.Password)),
      };
      props.submitHandler(tempValues);
      return;
    }
    setCurrentStep((prev) => prev + 1);
  };

  const handlePrevStep = (newData: any) => {
    setData((prev) => ({ ...prev, ...newData }));
    setCurrentStep((prev) => prev - 1);
  };

  const steps = [
    <StepFactoryDetails
      next={handleNextStep}
      initalValues={data}
      isLoading={props.isLoading}
      onModalClosed={props.onModalClosed}
      id={props.id}
    />,
    <StepUserDetails
      next={handleNextStep}
      prev={handlePrevStep}
      initialValues={data}
      id={props.id}
      isLoading={props.isLoading}
      onModalClosed={props.onModalClosed}
    />,
  ];

  return (
    <div>
      {props.isLoading && <FormLoader loading={props.isLoading} contained />}
      {steps[currentStep]}
    </div>
  );
};

export default observer(AddFactoryForm);
